import { Language } from './language.enum'
import { AnyAction } from 'redux'

export const ACTION_SETTINGS_LANGUAGE_SET = 'ACTION_SETTINGS_LANGUAGE_SET'

export const actionSettingsSetLanguage = (language: Language): AnyAction => ({
    type: ACTION_SETTINGS_LANGUAGE_SET,
    language,
})
